import { GroupMetric } from 'types/DeviceMetric'
import { useEffect, useState } from 'react'

import Api from 'services/api'

const useGroups = () => {
  const [groups, setGroups] = useState<Array<GroupMetric>>([])
  const [areGroupsLoaded, setAreGroupsLoaded] = useState(false)

  useEffect(() => {
    setAreGroupsLoaded(false)

    Api.DeviceMetrics.getGroupsList()
      .then((res) => {
        setGroups(res)
        setAreGroupsLoaded(true)
      })
      .catch(() => {
        setGroups([])
        setAreGroupsLoaded(true)
      })
  }, [])

  return { groups, areGroupsLoaded }
}

export default useGroups
